// extracted by mini-css-extract-plugin
export default {"dashboard_container":"ADMIN_DASHBOARD_dashboard_container__XV5Pn","component_container":"ADMIN_DASHBOARD_component_container__wavUv"};